import * as React from "react";

type TCtx = {
  open: boolean;
  setOpen: (o: boolean) => void;
  mouse: { x: number; y: number };
  setMouse: (m: { x: number; y: number }) => void;
};
const Ctx = React.createContext<TCtx | null>(null);

export function TooltipProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export function Tooltip({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = React.useState(false);
  const [mouse, setMouse] = React.useState({ x: 0, y: 0 });
  return <Ctx.Provider value={{ open, setOpen, mouse, setMouse }}>{children}</Ctx.Provider>;
}

type TrigProps = React.HTMLAttributes<HTMLSpanElement> & { asChild?: boolean };
export function TooltipTrigger({ asChild, children, ...rest }: TrigProps) {
  const ctx = React.useContext(Ctx)!;
  const props = {
    onMouseEnter: () => ctx.setOpen(true),
    onMouseLeave: () => ctx.setOpen(false),
    onMouseMove: (e: React.MouseEvent) => ctx.setMouse({ x: e.clientX, y: e.clientY }),
    ...rest,
  };
  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children as any, props);
  }
  return (
    <span className="inline-block" {...props}>
      {children}
    </span>
  );
}

type ContentProps = React.HTMLAttributes<HTMLDivElement>;
export function TooltipContent({ className = "", children, ...rest }: ContentProps) {
  const ctx = React.useContext(Ctx)!;
  if (!ctx.open) return null;
  const style: React.CSSProperties = {
    position: "fixed",
    top: Math.max(8, ctx.mouse.y - 40),
    left: ctx.mouse.x + 12,
    pointerEvents: "none",
  };
  return (
    <div
      style={style}
      className={
        "z-[60] rounded-md border bg-zinc-900 text-white text-xs px-2 py-1 shadow-lg " +
        "border-zinc-700 " +
        className
      }
      {...rest}
    >
      {children}
    </div>
  );
}
